import services from "@/services/service"

export default {
  namespaced: true,
  state: {
    channels: null,
    channel: null,
    lastChannelId: null,
    epgs: null,
    records: null,
    sidebar: null,
    category: null,
    search: null,
    single: false
  },
  mutations: {
    channels(state, data) {
      state.channels = data
    },
    channel(state, data) {
      state.channel = data
    },
    epgs(state, data) {
      state.epgs = data
    },
    records(state, data) {
      state.records = data
    },
    sidebar(state, data) {
      state.sidebar = data
    },
    category(state, data) {
      state.category = data === "all" ? null : data
    },
    search(state, data) {
      state.search = data
    },
    single(state, data) {
      state.single = data
    },
    lastChannelId(state, data) {
      state.lastChannelId = data
    }
  },
  getters: {
    privateCategories: () => ["Radio", "Adult"],
    isPrivateCategory: (state, getters) => getters.privateCategories.includes(state.category),
    allChannels: state => {
      if (!state.channels) return []

      return Object.values(state.channels)
        .sort((a, b) => {
          return a.sort - b.sort
        })
        .map((item, index) => {
          item.placement = _$.pad(index + 1, "000")
          return item
        })
    },
    channels(state, getters) {
      if (state.category === "favorites") return getters.allChannels.filter(item => item.favorite)

      return getters.allChannels
        .filter(item => {
          if (state.category) return item.groups.includes(state.category)

          return item.groups.filter(x => getters.privateCategories.includes(x)).length ? false : true
        })
        .filter(item => (state.search ? item.title.slugify().includes(state.search.slugify()) : true))
        .map((item, index) => {
          item.placement = _$.pad(index + 1, "000")
          return item
        })
    },
    channel(state) {
      return state.channel
    },
    firstChannel: (state, getters) => {
      return getters.channels[0]
    },
    defaultChannel: (state, getters) => {
      let channelIndex = 0,
        defChannel = __.device.config("defChannel.defChannel")

      channelIndex = getters.channels.find(el => el.id == defChannel)
      return channelIndex || getters.firstChannel
    },
    lastChannel: (state, getters) => {
      if (!state.lastChannelId) return null
      return getters.allChannels.find(ch => ch.id == state.lastChannelId) || null
    },
    categories: (state, getters) => {
      return getters.allChannels
        .map(channel => channel.groups)
        .flat()
        .filter(_$.unique)
    },
    sidebar(state) {
      return state.sidebar
    },
    category(state) {
      return state.category
    },
    search(state) {
      return state.search
    },
    single(state) {
      return state.single
    },
    favoritesChannels(state, getters) {
      return getters.allChannels.filter(item => item.favorite)
    },
    completedRecords(state) {
      if (!state.records) return []
      return state.records.filter(record => record.state === 2)
    },
    processingRecords(state) {
      if (!state.records) return []
      return state.records.filter(record => [0, 1].includes(record.state))
    }
  },
  actions: {
    async fetchChannels(context) {
      const channels = await __.api.get.channels().then(data => {
        if (!Array.isArray(data) || !data.length) return false

        const channels = {}
        for (const channel of data) {
          channel.epg = null
          channel.subtitle = null
          channel.language = null
          channel.placement = "000"
          channel.favorite = __.guest.isFavoriteChannel(channel.id)

          channels[channel.id] = channel
        }
        return channels
      })

      if (__.device.config("catchup.epg")) {
        await context.dispatch("fetchEpgs", channels)
        await services.dvr.init(channels)
        await services.epg.sync(channels)
      }
      await context.dispatch("fetchRecords")

      context.commit("channels", channels)

      const savedLastChannelId = __.device.get("last_channel") || 0
      if (savedLastChannelId && _$.true(__.device.config("last_channel_startup.last_channel_startup")))
        context.commit("lastChannelId", savedLastChannelId)

      await context.dispatch("services/fetchOrders", null, { root: true })
      return true
    },
    async fetchEpgs(context, channels) {
      const epg_ids = Object.values(channels)
        .map(channel => channel.epg_id)
        .filter(epg_id => epg_id)

      if (!epg_ids.length) {
        context.commit("epgs", {})
        return
      }

      const epgs = await __.api.get.epgs(epg_ids)
      context.commit("epgs", epgs || {})
      return true
    },
    async fetchRecords(context) {
      if (!__.device.config("channel.record")) return false
      __.api.get.records().then(records => context.commit("records", records || []))
    }
  }
}
